import React from 'react'

export interface IVerifyButtonProps {
  isVerified?: boolean
  singleField?: string
  updateStatus?: boolean
  verifyAction?: () => void
}

/**
 * Button to trigger verification process
 */
export const VerifyButton = ({ singleField, isVerified, verifyAction, updateStatus }: IVerifyButtonProps) => {
  if (!singleField || isVerified !== false || !verifyAction) return null

  return (
    <button
      className="text-xs text-primary hover:underline cursor-pointer"
      onClick={verifyAction}
      disabled={!!updateStatus}
    >
      {!updateStatus ? 'Verify' : 'Requesting...'}
    </button>
  )
}
